import {getRequest} from './api'
import {Message} from 'element-ui'

export const isNotNullORBlank = (...args)=> {
  for (var i = 0; i < args.length; i++) {
    var argument = args[i];
    if (argument == null || argument == '' || argument == undefined) {
      Message.warning({message: '数据不能为空!'})
      return false;
    }
  }
  return true;
}
export const initMenu = (router, store)=> {
  if (store.state.routes.length > 0) {
    return;
  }
  var fmtRoutes = formatRoutes(datas);
  router.addRoutes(fmtRoutes);
  store.commit('initMenu', fmtRoutes);
  store.dispatch('connect');
}
	
var datas = [
	{"id":1,
	"path":"/home",
	"component":"Home",
	"name":"",
	"iconCls":"",
	"children":[],
		"meta":{"keepAlive":false,"requireAuth":true},
	},
	
	
	]
export const formatRoutes = (routes)=> {
  let fmRoutes = [];
  routes.forEach(router=> {
    let {
      path,
      component,
      name,
      meta,
      iconCls,
      children
    } = router;
    if (children && children instanceof Array) {
      children = formatRoutes(children);
    }
    let fmRouter = {
      path: path,
      component(resolve){
        if (component.startsWith("Home")) {
          require(['../components/' + component + '.vue'], resolve)
        } else if (component.startsWith("Order")) {
          require(['../components/order/' + component + '.vue'], resolve)
        } else if (component.startsWith("User")) {
          require(['../components/user/' + component + '.vue'], resolve)
        } else if (component.startsWith("Assistant")) {
          require(['../components/assistant/' + component + '.vue'], resolve)
        }
      },
      name: name,
      iconCls: iconCls,
      meta: meta,
      children: children
    };
    fmRoutes.push(fmRouter);
  })
  return fmRoutes;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js